module.exports = __webpack_public_path__ + "static/media/preview-stories-active.0c64e364.svg";